import { authStore } from "./auth";
import { useAuth } from "./auth/use-auth";
import type { AuthStatus, JwtClaims } from "./auth";

export interface Session {
  status: AuthStatus;
  user: { name: string; email: string } | null;
  claims: JwtClaims | null;
  accessToken: string | null;
  expiresAt: Date | null;
  refresh: () => Promise<string>;
  signOut: () => void;
}

export function useSession(): Session {
  const snapshot = useAuth();
  const user = snapshot.user
    ? { name: snapshot.user.name || snapshot.user.email, email: snapshot.user.email }
    : null;
  const expiresAt = snapshot.claims
    ? new Date(snapshot.claims.exp * 1000)
    : null;

  return {
    status: snapshot.status,
    user,
    claims: snapshot.claims,
    accessToken: snapshot.accessToken,
    expiresAt,
    refresh: authStore.refresh,
    signOut: () => authStore.logout(),
  };
}
